/** No-op function. Returns `null` to satisfy most React typings. */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function noop() {
  return null
}
